module.exports = __webpack_public_path__ + "media/preview/workshop@2x-90dcd220.png";